// src/shared/constants.ts
var DOCS_URL = "https://docs.tryabby.com/";
var ABBY_BASE_URL = "https://www.tryabby.com/";
var ABBY_AB_STORAGE_PREFIX = "__abby__ab__";
var ABBY_FF_STORAGE_PREFIX = "__abby__ff__";
var ABBY_RC_STORAGE_PREFIX = "__abby__rc__";
var ABBY_INSTANCE_KEY = "__abby_instance__";
var DEFAULT_FEATURE_FLAG_VALUE = false;
var ABBY_WINDOW_KEY = "__abby_data__";

export { ABBY_AB_STORAGE_PREFIX, ABBY_BASE_URL, ABBY_FF_STORAGE_PREFIX, ABBY_INSTANCE_KEY, ABBY_RC_STORAGE_PREFIX, ABBY_WINDOW_KEY, DEFAULT_FEATURE_FLAG_VALUE, DOCS_URL };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-2HPJHXZH.mjs.map